<div *ngIf="isLoading">Loading Payment Type List...</div>

<select *ngIf="!isLoading" [compareWith]="byId" class="form-control" name="paymentType"
        [(ngModel)]="model.paymentType" [required]="required">
  <option *ngFor="let singlePaymentType of paymentTypes" [ngValue]="singlePaymentType">{{ singlePaymentType.name
    }}
  </option>
</select>
